import { render, staticRenderFns } from "./LeasingPrescoreInputQuestion.vue?vue&type=template&id=5d33db3d&scoped=true&"
import script from "./LeasingPrescoreInputQuestion.vue?vue&type=script&lang=js&"
export * from "./LeasingPrescoreInputQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d33db3d",
  null
  
)

export default component.exports